module.exports = __webpack_public_path__ + "static/media/ic-mentee-file-on.be7c05e6.webp";